/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as Msdyn365 from "@msdyn365-commerce/core";

import { lTSGetATPDatesAsync } from "./AtpDataActionExtension.g";
import {
  IAtpItem,
  IGetATPDatesResponse,
} from "./AtpDataServiceEntities.g";

export type { IAtpItem, IGetATPDatesResponse };
export class BritaxGetAtpDatesInput implements Msdyn365.IActionInput {
  public atpItems: IAtpItem[];

  constructor(atpItems: IAtpItem[]) {
    this.atpItems = atpItems;
  }
  public getCacheKey = () => `BritaxGetAtpDates`;
  public getCacheObjectType = () => "BritaxGetAtpDates";
  public dataCacheType = (): Msdyn365.CacheType => "none";
}

const createBritaxGetAtpDateInput = (
  _args: Msdyn365.ICreateActionContext,
): Msdyn365.IActionInput => new BritaxGetAtpDatesInput([]);

export async function getAtpDatesAction(
  input: BritaxGetAtpDatesInput,
  ctx: Msdyn365.IActionContext,
): Promise<IGetATPDatesResponse> {
  return lTSGetATPDatesAsync({ callerContext: ctx }, input.atpItems);
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<IGetATPDatesResponse>>getAtpDatesAction,
  id: "BritaxGetAtpDates",
  input: createBritaxGetAtpDateInput,
});
